import { render, staticRenderFns } from "./nav_menu.vue?vue&type=template&id=474a0e08&scoped=true&"
import script from "./nav_menu.vue?vue&type=script&lang=js&"
export * from "./nav_menu.vue?vue&type=script&lang=js&"
import style0 from "./nav_menu.vue?vue&type=style&index=0&id=474a0e08&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474a0e08",
  null
  
)

export default component.exports